import { find, register } from '../../../../Javascript/Utils'

const component = el => {
  const componentPrefix = el.dataset.componentprefix
  const videoContainer = find(`.${componentPrefix}video`, el)
  const videoId = videoContainer.dataset.videoid
  const playButton = find(`.${componentPrefix}play-button`, el)
  const loader = find(`.${componentPrefix}loader`, el)
  let initialized = false
  let player

  const showElement = (el) => {
    el.classList.add(`${componentPrefix}active`)
  }

  const hideElement = (el) => {
    el.classList.remove(`${componentPrefix}active`)
  }

  const initializeVideo = () => {
    playButton.classList.remove(`${componentPrefix}active`)
    loader.classList.add(`${componentPrefix}active`)

    /* eslint-disable */
    if (typeof (YT) === 'undefined' || typeof (YT.Player) === 'undefined') {
      var tag = document.createElement('script')
      tag.src = 'https://www.youtube.com/iframe_api'
      var firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
      window.onYouTubePlayerAPIReady = function() {
        onYouTubePlayer()
      }
    }

    const onYouTubePlayer = () => {
      player = new YT.Player(videoContainer, {
        width: '1920',
        height: '1080',
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          showinfo: 0,
          modestbranding: 1,
        },
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
      })
    }
    /* eslint-enable */
  }

  playButton.addEventListener('click', () => {
    if (initialized) {
      player.playVideo()
    } else {
      initializeVideo()
    }
  })

  const onPlayerReady = (event) => {
    initialized = true
    player.setPlaybackQuality('highres')
    hideElement(loader)
    el.classList.add(`${componentPrefix}-is-playing`)
    player.playVideo()
  }

  const onPlayerStateChange = (event) => {
    if (initialized) {
      /* eslint-disable */
      if (event.data === YT.PlayerState.PLAYING) {
        hideElement(playButton)
      } else if (event.data === YT.PlayerState.ENDED) {
        player.playVideo()
      } else {
        showElement(playButton)
      }
      /* eslint-enable */
    }
  }
}

register('YouTube', component)
